import { resolutionNoticeClasses } from '../bloodTests.styles';
import type { BloodTestResolutionNoticeProps } from '../bloodTests.types';

export const BloodTestResolutionNotice = ({ unresolvedTerms }: BloodTestResolutionNoticeProps) =>
  unresolvedTerms.length ? (
    <output className={resolutionNoticeClasses}>
      <span>Ekki tókst að velja þessar rannsóknir sjálfkrafa:</span>
      <span>{unresolvedTerms.join(', ')}</span>
      <span>Veldu viðeigandi rannsóknir handvirkt.</span>
    </output>
  ) : null;
